import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { GNB } from "~/widgets/gnb/GNB";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 1280px;
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export function AppLayout() {
  return (
    <Container>
      <GNB />
      <Main>
        <Outlet />
      </Main>
    </Container>
  );
}
